import React from 'react';
import { Container } from '@mui/material';
import DashboardLayout from '../../layouts/DashboardLayout';
import AssistedRegistrationForm from '../../components/Franchisee/AssistedRegistrationForm';
export default function AssistedRegistrationPage() {
  return <DashboardLayout><Container maxWidth="md"><AssistedRegistrationForm /></Container></DashboardLayout>;
}
